import React from 'react';

import {
  CheckIcon,
  CircleSlashIcon,
  HourglassIcon,
} from '@primer/octicons-react';

import capitalize from 'lodash/capitalize';

import { IconBadge } from '../../common/Badge/Badge';

const mapStatusToLabel = (status) => {
  if (status === 'Ready') {
    return 'Active'
  }
  if (status === 'Error') {
    return status;
  }

  return 'Inactive';
}

const mapStatusToColor = (status) => {
  if (status === 'Ready') {
    return 'bg-green-500';
  }
  if (status === 'Error') {
    return 'bg-red-500';
  }

  return 'bg-gray-500';
}

const mapStatusToIcon = (status) => {
  if (status === 'Ready') {
    return CheckIcon;
  }
  if (status === 'Error') {
    return CircleSlashIcon;
  }

  return HourglassIcon;
}

export const OrchestrationStatusBadge = ({ status, textColor = 'text-white' }) => {
  const capitalizedStatus = capitalize(status);
  return (
    <IconBadge
      className="p-2 w-28"
      bgColor={mapStatusToColor(capitalizedStatus)}
      icon={mapStatusToIcon(capitalizedStatus)}
      textColor={textColor}
    >
      {mapStatusToLabel(capitalizedStatus)}
    </IconBadge>
  )
}

export default OrchestrationStatusBadge;
